import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'users' },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      children: [
        {
          path: 'users',
          name: 'users',
          component: () =>
            import(/* webpackChunkName: "users" */ '@/views/Home/Users')
        },
        {
          path: 'users/:id',
          name: 'user.details',
          component: () =>
            import(
              /* webpackChunkName: "users" */ '@/views/Home/Users/UserDetails'
            )
        },
        {
          path: 'incidents',
          name: 'incidents',
          component: () =>
            import(
              /* webpackChunkName: "incidents" */ '@/views/Home/Incidents/index'
            )
        },
        {
          path: 'incident/reports',
          name: 'incident.reports',
          component: () =>
            import(
              /* webpackChunkName: "reports" */ '@/views/Home/Reports/Incident'
            )
        },
        {
          path: 'incident/reports/:id',
          name: 'incident.report-details',
          component: () =>
            import(
              /* webpackChunkName: "reports" */ '@/views/Home/Reports/IncidentDetails'
            )
        },
        {
          path: 'user/reports',
          name: 'user.reports',
          component: () =>
            import(
              /* webpackChunkName: "reports" */ '@/views/Home/Reports/User'
            )
        },
        {
          path: 'user/reports/:id',
          name: 'user.reports-details',
          component: () =>
            import(
              /* webpackChunkName: "reports" */ '@/views/Home/Reports/UserDetails'
            )
        },
        {
          path: 'comment/reports',
          name: 'comment.reports',
          component: () =>
            import(
              /* webpackChunkName: "reports" */ '@/views/Home/Reports/Comment'
            )
        },
        {
          path: 'comment/reports/:id',
          name: 'comment.reports-details',
          component: () =>
            import(
              /* webpackChunkName: "reports" */ '@/views/Home/Reports/CommentDetails'
            )
        }
      ]
    }
  ]
})
